<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <form @submit.prevent="submitForm">
        <div class="container">
          <div class="area_wrap">
            <div class="title_wrap">
              <h3>개인정보 입력</h3>
              <p class="warn">필수입력정보입니다.</p>
            </div>
              <div class="aw_context tel userInput">
                <div class="warnSpace">
                  <p class="warn"  v-text="form.userName.errorTxt" v-if="form.userName.hasError"></p>
                </div>
                <div class="article require" :class="{errorLaise : form.userName.hasError}">
                  <div class="inputHeader">
                    <p>이름</p>
                  </div>
                  <input type="text" placeholder="이름을 입력해주세요." v-model="form.userName.value" maxlength="21" @keyup="blurName()" class="userInput"/>
                </div>
                <div class="warnSpace">
                  <p class="warn"  v-text="form.birthDate.errorTxt" v-if="form.birthDate.hasError"></p>
                </div>
                <div class="article require" :class="{errorLaise : form.birthDate.hasError}">
                  <div class="inputHeader">
                    <p>생년월일</p>
                  </div>
                  <input type="text" placeholder="YYYY-MM-DD" v-model="form.birthDate.value" maxlength="10" @keyup="blurBirth()" @keydown="formatBirthNumber(form.birthDate.value)" class="birthInput"/>
                </div>
                <div class="warnSpace">
                  <p class="warn"  v-text="form.mail.errorTxt" v-if="form.mail.hasError"></p>
                </div>
                <div class="article require half" :class="{errorLaise : form.mail.hasError}">
                  <div class="inputHeader">
                    <p>이메일</p>
                  </div>
                  <div class="halfWrap">
                    <input type="text" v-model="mailInput.value" @keyup="blurMailInput()">
                    <span class="narrow">@</span>
                    <input type="text" v-model="mailInput2.value" @keyup="blurMailInput2()" @blur="blurMailInput2()"/>
                  </div>
                </div>
              </div>
          </div>
        </div>
      <div class="btnWrap" :class="{visible : form.userName.flag && form.birthDate.flag && form.mail.flag}">
        <button type="submit" :disabled="!checkAll()">아이디 찾기</button>
      </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
    :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapState, mapActions, mapMutations } from 'vuex'
// import { Dert } from '@/assets/js/thanQAlert'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '입력한 값을 확인해 주세요.',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '아이디 찾기',
        progressNum: '50%',
        chapterNum: 2,
        prevUrl: '/'
      },
      mailInput: {
        value: '',
        flag: false
      },
      mailInput2: {
        value: '',
        flag: false
      },
      form: {
        userName: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        birthDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        mail: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      },
      setCount: false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    blurName () {
      this.form.userName.flag = false
      this.checkName()
    },
    checkName () {
      if (this.form.userName.flag) return true

      const name = this.form.userName.value.replace(/\s/gi, '')
      if (name === '') {
        this.form.userName.hasError = true
        this.form.userName.errorTxt = '이름을 입력해주세요.'
        return false
      }
      // const isHan = /^[가-힣]{2,5}$/
      // if (!isHan.test(name)) {
      //   this.form.userName.hasError = true
      //   this.form.userName.errorTxt = '2~5자리의 한글만 입력이 가능합니다.'
      //   return false
      // }
      this.form.userName.flag = true
      this.form.userName.hasError = false
      this.form.userName.errorTxt = ''
      return true
    },
    blurBirth () {
      this.form.birthDate.flag = false
      this.checkBirth()
    },
    checkBirth () {
      if (this.form.birthDate.flag) return true

      const birth = this.form.birthDate.value.replace(/\s/gi, '')
      if (birth === '') {
        this.form.birthDate.hasError = true
        this.form.birthDate.errorTxt = '생년월일을 입력해주세요.'
        return false
      }
      const isBirthDate = /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
      if (!isBirthDate.test(birth)) {
        this.form.birthDate.hasError = true
        this.form.birthDate.errorTxt = '생년월일을 바르게 입력해주세요.'
        return false
      }
      this.form.birthDate.flag = true
      this.form.birthDate.hasError = false
      this.form.birthDate.errorTxt = ''
      return true
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    },
    formatBirthNumber (obj) {
      this.form.birthDate.value = this.formatBirth(obj)
    },
    blurMailInput () {
      this.form.mail.flag = false
      this.checkMailInput()
    },
    checkMailInput () {
      if (this.form.mail.flag) return true
      const input = this.mailInput.value.replace(/\s/gi, '')
      if (input === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      this.mailInput.flag = true
      this.blurEmail()
      return true
    },
    blurMailInput2 () {
      this.form.mail.flag = false
      this.checkMailInput2()
    },
    checkMailInput2 () {
      if (this.form.mail.flag) return true
      const input = this.mailInput2.value.replace(/\s/gi, '')
      if (input === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      this.mailInput2.flag = true
      this.blurEmail()
      return true
    },
    blurEmail () {
      this.form.mail.flag = false
      this.checkEmail()
    },
    checkEmail () {
      if (this.form.mail.flag && this.mailInput.flag && this.mailInput2.flag) return true

      const email = this.mailInput.value + '@' + this.mailInput2.value
      this.form.mail.value = email
      console.log('email::: ', email)
      if (email === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      // eslint-disable-next-line no-useless-escape
      const isEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!isEmail.test(email)) {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일 형식에 맞지 않습니다.'
        return false
      }
      this.form.mail.flag = true
      this.form.mail.hasError = false
      this.form.mail.errorTxt = ''
      return true
    },
    checkAll () {
      return !!(this.form.userName.flag && this.form.birthDate.flag && this.form.mail.flag)
    },
    submitForm () {
      if (this.checkAll()) {
        this.formAction()
      } else {
        if (!this.form.userName.flag) {
          this.popupSet.content = '이름을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.userName.hasError = true
          this.form.userName.errorTxt = '이름을 확인해주세요'
          // document.querySelector('.userInput').focus()
          return false
        }
        if (!this.form.birthDate.flag) {
          this.popupSet.content = '생년월일을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.birthDate.hasError = true
          this.form.birthDate.errorTxt = '생년월일을 확인해주세요'
          // document.querySelector('.birthInput').focus()
          return false
        }
        if (!this.form.mail.flag) {
          this.popupSet.content = '이메일을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.mail.hasError = true
          this.form.mail.errorTxt = '이메일을 확인해주세요.'
          // document.querySelector('.mailInput').focus()
          return false
        }
      }
    },
    async formAction () {
      try {
        const userData = {
          userName: this.form.userName.value,
          birthDate: this.form.birthDate.value,
          mail: this.form.mail.value
        }
        await this.ID_FIND(userData)
        this.SET_REFERRER(window.location.href)
        await this.$router.push('/idFindDone')
        // this.$store.commit('setId', data.response.id)
      } catch (error) {
        console.log('error :', error);
        console.log('아이디 찾기 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          if (error.data.response.message === 'There is no matched member information.') {
            this.popupSet.content = '입력하신 정보와 일치하는 회원이 없습니다. 다시 한 번 확인해 주세요.'
          } else if (error.response !== undefined) {
            this.popupSet.content = '입력하신 정보와 일치하는 회원이 없습니다. 다시 한 번 확인해 주세요.'
          } else {
            this.popupSet.content = errorParser.parse(error)
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.initForm()
      }
    },
    ...mapActions([
      'ID_FIND'
    ]),
    initForm () {
      this.form.userName.value = ''
      this.form.birthDate.value = ''
      this.form.mail.value = ''
      this.mailInput.value = ''
      this.mailInput2.value = ''
      this.form.userName.flag = false
      this.form.birthDate.flag = false
      this.form.mail.flag = false
      this.mailInput.flag = false
      this.mailInput2.flag = false
    },
    nextDone () {
      this.$router.push({ name: 'idFindDone' })
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/login')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>
<style lang="scss" scoped>
</style>
